.project-option {
  white-space: nowrap;
}

i.material-icons {
  cursor: pointer;
  position: relative;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  /* width: 120px; */
  background-color: black;
  color: white;
  text-align: center;
  padding: 5px 0;

  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* Expand history*/

gl-table tbody tr.history {
  background-color: #F8F8FF;
}

gl-table tbody tr.hidden {
  visibility: hidden
}

tr.history {
  background-color: Gainsboro
}
